module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAAXNSR0IArs4c6QAAAB5QTFRFAAAAKGjvKmrvLGjsLGnrK2nrK2jrLGnsLGjsLGnsRf5ujgAAAAl0Uk5TACAwv8DP0O/w5wTDgQAAAE9JREFUGNNjyJw5s4gBCNRnzpzKMMPFxRHEEXFx6WSYwgAHnsRyWhAcDwZFBEeJgV4AxVIk57iT5Z/pxsZGIJaysXElAzComkAcjZkzpwEAeTUVxVnXTbAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/fj-look.png
// module id = 8nH8
// module chunks = 0